import { useMemo } from "react"

import { connect } from "scrivito"
import { WithChildren } from "shared/types/WithChildren"

import { useProductPageContext } from "../context/ProductPageContext"
import { ProductPageImportContext } from "../context/ProductPageImportContext"

function ProductPageImportProviderComponent({ children }: WithChildren) {
  const { productType, buildingReferenceObjs, getFiles, getQuickInfos } =
    useProductPageContext()

  const hasDownloads = (getFiles({ productType })?.length ?? 0) > 0
  const hasQuickInfos = !!getQuickInfos({ productType })
  const hasReferences = (buildingReferenceObjs?.length ?? 0) > 0

  const contextValue = useMemo(
    () => ({ hasQuickInfos, hasDownloads, hasReferences }),
    [hasDownloads, hasQuickInfos, hasReferences]
  )

  return (
    <ProductPageImportContext.Provider value={contextValue}>
      {children}
    </ProductPageImportContext.Provider>
  )
}

export const ProductPageImportProvider = connect(
  ProductPageImportProviderComponent
)
